import { NullStr, Peeky, RootKey } from "./peeky";
import $ from 'jquery';

export class PeekyActivator{

  constructor(pk: Peeky, selector: string) {
	
    pk.on('postPushState', activate);
    pk.on('prepareSwitch', activate);
    function activate(param) {
      let that: Peeky = this;
      let stateUrl = (param && param.location) ? param.location.url : pk.paramToUrl();
      let rootPath = that.property('rootPath');

      // Add default arguments that aren't in the actual URL
      let stateParam = this.urlToParam(stateUrl, false, true);
      let stateRootParam = stateParam[RootKey];
      let statePath = stateRootParam._arg || {};
      let treePaths = getTreePaths.call(that.root);
      
      // Lookup argument trees
      // On a single-page site, sections could be active even if they're not in the /current/path/
      function getTreePaths(basePath) {
        let state = this.state();
        let catchPath = this.catchPath();
        let paths = [];
        basePath = basePath || [];
        if (this.catchPathTree) {
          basePath[basePath.length-1] = this.catchPathTree;
        }

        for (let i=0; i<catchPath; i++) {
          let arg = this.getArg(i);
          //if (arg) {
            basePath.push(arg || '');
          //}
        }
        for (let k in state.children) {
          paths = paths.concat(getTreePaths.call(state.children[k], basePath.slice(0)));
        }

        if (!paths.length && catchPath) {
          paths.push(basePath);
        }
        return paths;
      }

      // Lookup all currently visible links/items
      pk.$find(selector).each(function maybeActivate() {
        let interactor = this;
        let $interactor = $(interactor);
        let href = $interactor.attr('href') || $interactor.attr('xlink:href') || $interactor.attr('action') || $interactor.data('href') || '';

        if (rootPath && href.indexOf('/') === 0) {
          if (!that.underRoot(rootPath + href)) {
            return;
          }
        } else if (href === '' || typeof(href) === 'undefined') {
          return;
        } else if (!that.underRoot(href)) {
            return;
        }

        let interactorParam = that.urlToParam(href, true);
        let interactorRootParam = interactorParam[RootKey] || {};
        let interactorArgs = interactorRootParam._arg || {};
        
        let exactMatch = true;
        let match = true;
        let exactTreeMatch = true;
        let treeMatch = true;
        
        // Check if all interactor-path-arguments are in state
        if (!checkPath(interactorArgs, statePath)) {
          match = false;
          exactMatch = false;
        }

        // Check if all state-path-arguments are in interactor
        if (match && !checkPath(statePath, interactorArgs)) {
          exactMatch = false;
        }

        // Check if all interactor-queries are in state
        if (match && !checkQuerystring(interactorParam, stateParam)) {
          exactMatch = false;
        }

        // Check if all state-queries are in interactor
        if (match && exactMatch && !checkQuerystring(stateParam, interactorParam)) {
          exactMatch = false;
        }

        if (!checkPaths([interactorArgs], treePaths)) {
          treeMatch = false;
          exactTreeMatch = false;
        }

        // Check if all state-path-arguments are in interactor
        if (!checkPaths(treePaths, [interactorArgs])) {
          exactTreeMatch = false;
        }
        
        if (match) {
          addClass($interactor, '_active');
        } else {
          removeClass($interactor, '_active');
        }
        if (exactMatch) {
          addClass($interactor, '_activeExact');
        } else {
          removeClass($interactor, '_activeExact');
        }
        if (treeMatch) {
          addClass($interactor, '_treeActive');
        } else {
          removeClass($interactor, '_treeActive');
        }
        if (exactTreeMatch) {
          addClass($interactor, '_treeActiveExact');
        } else {
          removeClass($interactor, '_treeActiveExact');
        }
      });
    };
  }
}


function isEmpty(str, allowZero?: boolean): boolean {
  let result: boolean;
  if (typeof(str) === 'object') {
    for (let k in str) {
      if (!isEmpty(str[k], allowZero)) {
        return false;
      }
    }
    result = true;
  } else {
    result = (str === '' || str === NullStr || typeof(str) === 'undefined');
    if (!result && allowZero) {
      result = result || str === 0 || str === '0';
    }
  }
  return result;
}


function checkQuerystring(aObj, bObj, level?) {
  if (typeof(level) === 'undefined') level = 0;
  for (let aKey in aObj) {
    if (level === 0 && aKey === RootKey) {
      continue;
    }
    if (level === 1 && aKey === '_arg') {
      continue;
    }
    let aValue = aObj[aKey];
    let bValue = bObj[aKey];
    let aType = typeof(aValue);
    let bType = typeof(bValue);
    if (aType === 'object' && bType === 'object') {
      if (!checkQuerystring(aValue, bValue, level+1)) {
        return false;
      } else {
        continue;
      }
    }
    if (aValue === bValue) {
      continue;
    }
    if (isEmpty(aValue, true) && isEmpty(bValue, true)) {
      continue;
    }
    return false;
  }
  return true;
}


function addClass($element: JQuery, value: string) {
  let element = $element[0];
  if (element instanceof SVGElement) {
    let classes = $(element).attr('class');
    if (classes) {
      let index = classes.indexOf(value);
      if (index === -1) {
        classes = classes + " " + value;
        $(element).attr('class', classes);
      }
    } else {
      $(element).attr('class', value);
    }
  } else {
    $element.addClass(value);
  }
};


function removeClass($element, value) {
  let element = $element[0];
  if (element instanceof SVGElement) {
    let classes = $(element).attr('class');
    if (classes) {
      let index = classes.indexOf(value);
      if (index !== -1) {
        classes = classes.substring(0, index) + classes.substring((index + value.length), classes.length);
        $(element).attr('class', classes);
      }
    }
  } else {
    $element.removeClass(value);
  }
};


function checkPath(aObj, bObj) {
  let match = true;
  $.each(aObj, function(key) {
    let aValue = aObj[key];
    let bValue = bObj[key];
    if (aValue === bValue) return;
    if (isEmpty(aValue) && isEmpty(bValue)) return;
    match = false;
    return false;
  });
  return match;
};


function checkPaths(arrA, arrB) {
  let result = false;
  $.each(arrA, function(key, valA) {
    $.each(arrB, function(key, valB) {
      if (checkPath(valA, valB)) {
        result = true;
        return false;
      }
    });
    if (result) {
      return false;
    }
  });
  return result;
};